import { isUndef } from '@aviata/type-guards';
import type { Airflow } from '@aviata/platform-types';

/**
 * @note **baggage.pc** explanation comes from the admin panel
 */
function parse(baggage: Airflow.Segment.BaggageEntity) {
  const { value, unit, pc } = baggage;

  if (unit === 'PC' && !isUndef(pc)) {
    return { count: value, value: pc.value, unit: pc.unit };
  }

  const count = value === 0 ? 0 : 1;

  return { count, value, unit };
}

/**
 * @description representation of missing baggage
 */
const none = { count: 0, value: 0, unit: 'KG' };

export const baggageLib = {
  none,
  parse,
};
